var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3284FF",
    d: "M15 7.68a8.514 8.514 0 0 0-.131-1.453H7.662v2.906h4.375a4.597 4.597 0 0 1-1.675 2.457l2.257 1.799A7.834 7.834 0 0 0 15 7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3424",
    d: "M7.756 3.117a4.35 4.35 0 0 1 2.869 1.062l2.088-2.118a7.154 7.154 0 0 0-5-2.055C4.82-.007 2.163 1.632.825 4.256l2.563 1.958c.688-1.86 2.426-3.091 4.368-3.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB0",
    d: "m.875 11.206 2.469-1.97a4.611 4.611 0 0 1-.219-1.447c0-.538.096-1.071.281-1.575L.844 4.256a7.582 7.582 0 0 0 .031 6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26B14C",
    d: "M3.344 9.235.875 11.206c1.348 2.555 3.952 4.149 6.787 4.154a7.15 7.15 0 0 0 4.944-1.971L10.35 11.59a4.306 4.306 0 0 1-2.594.864c-1.99-.004-3.759-1.295-4.412-3.219Z"
  }))));
};
export default SvgGoogle;